module.exports = __webpack_public_path__ + "static/media/sign-alt.e7c1bdda.svg";